import { api } from "@/api/axios.ts";

export interface ApiOAuthAuthorizeParams {
  client_id: string;
  redirect_uri: string;
  code_challenge: string;
  code_challenge_method: string; // "S256"
  response_type: string; // "code"
  scope: string;
  state: string;
}

export interface ApiOAuthConsentRequired {
  consent_required: true;
  client_id: string;
  client_name: string;
  organization_id: number;
  scopes: string[];
}

export interface ApiOAuthRedirect {
  redirect_to: string;
}

export type ApiOAuthAuthorizeResponse = ApiOAuthConsentRequired | ApiOAuthRedirect;

export const apiOAuth = {
  getAuthorize: (params: ApiOAuthAuthorizeParams) =>
    api.get<ApiOAuthAuthorizeResponse>("/oauth/authorize", params),

  // Бэк ждёт form-data, а не JSON.
  postAuthorize: (params: ApiOAuthAuthorizeParams) => {
    const form = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => form.append(key, String(value)));
    return api.post<ApiOAuthRedirect>("/oauth/authorize", form, undefined, {
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
    });
  },
};
